__turbopack_context__.v({
  "defaultIcon": "MYeMeq_defaultIcon",
  "listText": "MYeMeq_listText",
  "spinner": "MYeMeq_spinner",
});
